export default {
  SET_DATA_IAM_VIOLATIONS(state, params) {
    state.gridData = params;
  },
  SET_COUNT_IAM_VIOLATIONS(state, params) {
    state.totalCount = params;
  },

  SET_SEARCH_PARAM_IAM_VIOLATIONS(state, params) {
    state.searchParam = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/security/violations/IamViolationMutation.js